import { makeStyles } from '@material-ui/styles';
import HeaderFilter from 'component/header-filter';
import StylistFilter from 'component/stylist-filter';
import ModalFull, { ETitleModal } from 'component/modal_full_screen';
import Sidebar from 'component/side_bar';
import { useAuth } from 'contexts/AuthContext';
import React, { CSSProperties, ReactElement, useEffect, useState } from 'react';
import Div100vh, { use100vh } from 'react-div-100vh';
import { useAppDispatch } from 'redux/store';
import themes from 'styles/themes';
import CustomHeader from './custom_header';
import { useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import utils from 'utils/utils';
import { globalActions } from 'redux/global/global.slice';
import { BottomNavigationPlaceHolder } from 'routes/BottomNavigationProvider';
const useStyles = makeStyles({
    backgroundImg: {
        // backgroundImage: `url(${stylistBgImg})`,
        backgroundPosition: 'center top 20%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 'inset 1000px 1000px 1000px rgba(0, 0, 0, 0.2)',
    },
    background: {
        backgroundColor: '#f2f2f2',
    },
    overlay: {
        background: '#000',
        width: '100%',
        position: 'absolute',
        left: 0,
        zIndex: 99,
        top: 0,
        opacity: '0.5',
    },
    sideBar: {
        position: 'fixed',
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        zIndex: 1000000,
        top: 0,
        bottom: 0,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
});

interface ICustomLayoutProps extends React.HTMLProps<HTMLDivElement> {
    title?: string;
    showBackBtn?: boolean;
    backTo?: string;
    showUserIcon?: boolean;
    showSideBarBtn?: boolean;
    showHeader?: boolean;
    showHeaderFilter?: boolean;
    hideBottomNav?: boolean;
    headerLeftBtn?: ReactElement;
    children?: Element | any;
    handler?: any;
    setInputSearch?: any;
    value?: any;
    containerStyle?: CSSProperties;
    isLogo?: Boolean;
    colorHeader?: String;
    isStylist?: boolean;
}

const containerStyle: CSSProperties = {
    flex: 1,
    position: 'relative',
    overflowY: 'hidden',
};

export default function CustomLayout({ showHeader = true, ...props }: ICustomLayoutProps) {
    const _containerStyle: CSSProperties = { ...containerStyle, ...props.containerStyle };
    const classes = useStyles();
    const { handleLogout } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [item, setItem] = useState<String>('');
    const [code, setCode] = useState<ETitleModal>(ETitleModal.FAQ);
    const dispatch = useAppDispatch();
    const handleClickOpen = (name: String, code: ETitleModal) => {
        setOpen(true);
        setItem(name);
        setCode(code);
    };

    const height: any = use100vh();

    const handleClose = () => {
        setOpen(false);
        setIsOpen(true);
    };
    const location = useLocation();
    const isStylist = location.pathname.indexOf(PATH.STYLISTS) >= 0;
    useEffect(() => {
        dispatch(globalActions.setBottomNavigationBar(!props.hideBottomNav));
    }, [props.hideBottomNav, dispatch]);

    return (
        <Div100vh
            style={{
                position: 'relative',
                // backgroundImage: props.title ? 'unset' : `url(${user.userType === UserType.Customer
                //     ? customerBgImg
                //     : approvedState
                //         ? stylistBgImg
                //         : waitingBgImg})`,
                ...props.containerStyle,
            }}
            className={`${!showHeader || props.title ? classes.background : classes.backgroundImg} ${props.className}`}
        >
            <div
                className="custom-layout-wrapper"
                style={{
                    height: `${utils.isAppInWidgetMode() ? '100vh' : height + 'px'}`,
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {showHeader && (
                    <div
                        className="header-wrap"
                        style={{
                            maxHeight: 48,
                            flex: 1,
                        }}
                    >
                        <CustomHeader
                            title={props.title}
                            showBackBtn={props.showBackBtn}
                            backTo={props.backTo}
                            showSideBarBtn={props.showSideBarBtn}
                            showUserIcon={props.showUserIcon}
                            setIsOpen={setIsOpen}
                            headerLeftBtn={props.headerLeftBtn}
                            colorHeader={props.colorHeader}
                            isStylist={props.isStylist}
                            style={{
                                background: `${
                                    props.colorHeader ? props.colorHeader : props.isLogo && themes.palette.primary.light
                                }`,
                            }}
                        />
                    </div>
                )}
                {props.showHeaderFilter && (
                    <div className="header-filter-wrap" style={{ height: 'auto', maxHeight: 90 }}>
                        {isStylist ? (
                            <StylistFilter
                                handler={props.handler}
                                setInputSearch={props.setInputSearch}
                                value={props.value}
                            />
                        ) : (
                            <HeaderFilter
                                handler={props.handler}
                                setInputSearch={props.setInputSearch}
                                value={props.value}
                            />
                        )}
                    </div>
                )}

                <div style={_containerStyle}>{props.children}</div>

                {!props.hideBottomNav && <BottomNavigationPlaceHolder />}
            </div>

            <div
                className={classes.overlay}
                style={{
                    display: `${isOpen ? 'block' : 'none'}`,
                    height: `100vh`,
                }}
                onClick={() => setIsOpen(false)}
            />
            <div
                className={classes.sideBar}
                style={{
                    height: `${utils.isAppInWidgetMode() ? '100vh' : height + 'px'}`,
                    display: `${isOpen ? 'block' : 'none'}`,
                }}
            >
                <Sidebar
                    item={item}
                    height={`${utils.isAppInWidgetMode() ? '100vh' : height + 'px'}`}
                    handleClickOpen={handleClickOpen}
                    setIsOpen={setIsOpen}
                    handleLogout={handleLogout}
                />
            </div>
            <ModalFull open={open} handleClose={handleClose} title={item} modal_code={code} />
            {/* {loadingStyle.loading && (
                <LoadingDataSpinner />
            )} */}
        </Div100vh>
    );
}
